import AiSearchPage from './components/AiSearchPage';
import {
    AiSearchProfilePopoutContext,
    useAiSearchProfilePopoutContextProvider,
} from './components/AiSearchProfilePopout/AiSearchProfilePopoutContext';
import IdentifiedPageContent from './components/IdentifiedList/IdentifiedPageContent';
import {
    IdentifiedListContext,
    useIdentifiedListContextProvider,
} from './components/IdentifiedList/utils/IdentifiedListContext';

const IdentifiedAiSearchPage = () => {
    return (
        <AiSearchPage>
            <AiSearchProfilePopoutContext.Provider
                value={useAiSearchProfilePopoutContextProvider({ hideEmailThreads: true })}
            >
                <IdentifiedListContext.Provider value={useIdentifiedListContextProvider()}>
                    <IdentifiedPageContent />
                </IdentifiedListContext.Provider>
            </AiSearchProfilePopoutContext.Provider>
        </AiSearchPage>
    );
};

export default IdentifiedAiSearchPage;
